function giftLogic(event) {
	console.log('giftLogic', event);
	const gifts = window.cartBarLevels.filter((mappedThreshold) => mappedThreshold.type === 'gift');
	if (gifts.length === 0) return;
	let removedGiftIds = [];
	if (event.detail.cart.items_removed?.length > 0) {
		removedGiftIds = event.detail.cart.items_removed
			.map((item) => item.variant_id)
			.filter((variantId) => gifts.some((gift) => gift.giftId === variantId));
	}
	const updates = {};
	gifts.forEach((gift) => {
    const itemAlreadyInCart = event.detail.cart.items.some((item) => item.variant_id === gift.giftId);
    if (!removedGiftIds.includes(gift.giftId)) {
      if (event.detail.cart.total_price >= gift.threshold && !itemAlreadyInCart) {
        updates[gift.giftId] = 1;
      } else if (event.detail.cart.total_price < gift.threshold && itemAlreadyInCart) {
        updates[gift.giftId] = 0;
      }
    }
	});
	if (updates) {
		fetch(window.Shopify.routes.root + 'cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ updates }),
		})
			.then(async (response) => {
				if (response.ok) {
					if (!window.buyXGetY) {
						document.documentElement.dispatchEvent(
							new CustomEvent('cart:refresh', {
								bubbles: true,
							}),
						);
					} else {
            document.documentElement.dispatchEvent(
              new CustomEvent('dispatch:buyXGetY', {
                detail: { baseEvent: event },
                bubbles: true,
              }),
            );
					}
				}
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	}
}

document.addEventListener('DOMContentLoaded', () => {
	if (!window.cartBarLevels) return;
	document.addEventListener('cart:change', (event) => giftLogic(event));
});
